export default __webpack_public_path__ + "static/media/img13.f728ab9f.PNG";